import styled from 'styled-components';
import Text from '@text';
import themedColor from '../../../../styles/theme/themed-color';
import styleUtils from '../../../../styles/style.utils';
import themedFontSize from '../../../../styles/theme/themed-font-size';

const MobileButton = styled.div`
  border: 1px solid ${themedColor('GRAY')};
  padding: ${styleUtils.px(32)};
  margin-bottom: ${styleUtils.px(24)};
  font-size: ${themedFontSize('BUTTON_M')};
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const Arrow = styled.div`
  width: ${styleUtils.px(8)};
  height: ${styleUtils.px(8)};
  border-right: ${styleUtils.px(1)} solid ${themedColor('TEXT_DISABLED')};
  border-top: ${styleUtils.px(1)} solid ${themedColor('TEXT_DISABLED')};
  margin-left: auto;
  transform: rotate(45deg) translate(2px, 2px);
`;

const StyledText = styled(Text)`
  &.ucf-paragraph {
    margin-right: ${styleUtils.px(32)};
    margin-bottom: 0;
    letter-spacing: normal;
    max-width: calc(100% - ${styleUtils.px(32)} - ${styleUtils.px(12)});
    font-size: ${themedFontSize('BUTTON_M')};
  }
`;

const MerchantButtonComponents = { MobileButton, Arrow, StyledText };

export default MerchantButtonComponents;
